import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import { CustomRadio } from "~/components/ui/radioBox";
import styles from "../../index.module.scss";
import type { FieldComponentProps } from "../../types";

const FileOptions: React.FC<FieldComponentProps> = ({ options, onChange, isReadOnly = false }) => {
  const handleBooleanOptionChange = (key: string) => (checked: boolean) => {
    onChange(key, checked);
  };

  const handleRadioChange = (key: string) => (value: string) => {
    onChange(key, value);
  };

  const thumbnailSizeOptions = [
    { value: "50x50", label: "50x50" },
    { value: "150x150", label: "150x150" },
    { value: "250x250", label: "250x250" },
    { value: "500x500", label: "500x500" },
  ];

  return (
    <div className={styles["optionSection"]}>
      <div className={styles["optionGroup"]}>
        <h4>ファイル設定</h4>

        {/* FILEはサンプルレコード生成時にLLMが有効な値を生成できないため、必須設定を除外 */}

        <div className={styles["checkboxOption"]}>
          <CustomCheckbox
            label="フィールド名を表示しない"
            checked={options.noLabel === true}
            onChange={handleBooleanOptionChange("noLabel")}
            disabled={isReadOnly}
          />
        </div>
      </div>

      <div className={styles["optionGroup"]}>
        <h4>サムネイルの大きさ</h4>
        <div className={styles["radioGroup"]}>
          <div className={styles["radioOptions"]}>
            {thumbnailSizeOptions.map((option) => (
              <CustomRadio
                key={option.value}
                name="thumbnailSize"
                label={option.label}
                value={option.value}
                checked={options["thumbnailSize"] === option.value}
                onChange={handleRadioChange("thumbnailSize")}
                disabled={isReadOnly}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileOptions;
